'use client';

import clsx from 'clsx';
import React, { useEffect, useRef } from 'react';

import { whiteWrapper, wrapper } from './main-header.css';

type MainHeaderWrapperProps = React.PropsWithChildren<{
  variant?: 'white' | undefined;
}>;

export function MainHeaderWrapper({
  children,
  variant,
}: MainHeaderWrapperProps) {
  const header = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function isScrolling() {
      if (header.current !== null) {
        const offset = window.scrollY;

        if (offset !== 0 && !header.current.classList.contains('scrolled')) {
          header.current.classList.add('scrolled');
        } else if (
          offset === 0 &&
          header.current.classList.contains('scrolled')
        ) {
          header.current.classList.remove('scrolled');
        }
      }
    }

    window.addEventListener('scroll', isScrolling);

    isScrolling();

    return () => {
      window.removeEventListener('scroll', isScrolling);
    };
  });

  return (
    <header
      ref={header}
      className={clsx(wrapper, {
        [whiteWrapper]: variant === 'white',
      })}
    >
      {children}
    </header>
  );
}
